import { render, staticRenderFns } from "./CFormText.vue?vue&type=template&id=f45bc666&scoped=true&"
import script from "./CFormText.vue?vue&type=script&lang=js&"
export * from "./CFormText.vue?vue&type=script&lang=js&"
import style0 from "./CFormText.vue?vue&type=style&index=0&id=f45bc666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45bc666",
  null
  
)

export default component.exports